import { useState, useEffect } from 'react'

// Forgot why we need this
export const RepeaterSelect = (props) => {

  const [selectData, setSelectData] = useState(props.value || { choices: {}, value: null});
  useEffect(() => props.onChange ? props.onChange(selectData) : null, [selectData])

  return tangibleFields.render({
    name: 'contentChoices',
    type: 'select',
    choices: selectData.choices,
    value: selectData.value,
    onChange: (val) => {
      setSelectData({...selectData, value: val})
    }
  })
}
